// removed by extract-text-webpack-plugin
module.exports = {"container":"container___Cmmob","content":"content___FvPZp","scrollContent":"scrollContent___22ZgU","marquee":"marquee___SydWI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MarqueeText/index.modules.less
// module id = 759
// module chunks = 438